import { Chip } from "~/ui";

export const StatusBadge = ({ isAvailable }: { isAvailable: boolean }) => (
  <Chip type={isAvailable ? "success" : "neutral"}>
    {isAvailable ? "Available for Booking" : "Unavailable for Booking"}
  </Chip>
);
